/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface InsuranceInfoModel {
  member_id?: string | null;
  group_number?: string | null;
  carrier_name?: string | null;
  plan_name?: string | null;
  rx_bin?: string | null;
  rx_pcn?: string | null;
  rx_group?: string | null;
  bridge_payer_id?: string | null;
  curai_payer_id?: string | null;
  user_is_policy_holder?: boolean | null;
  medicare_beneficiary_id?: string | null;
}
